import React from 'react'
import { Marquee, HudsonMarquee, SingleMarquee } from '../components/ui/marquee'

const MarqueeDemoPage: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <div className="py-12 px-4">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-12">
            <h1 className="text-4xl font-bold text-gray-900 mb-4">
              Marquee Banner Component
            </h1>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto">
              Scrolling text banner based on Figma design. Perfect for highlighting key messaging 
              and creating visual interest across the website.
            </p>
          </div>

          <div className="space-y-12">
            {/* Single Marquee */}
            <div>
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">
                Single Marquee Banner
              </h2>
              <p className="text-gray-600 mb-6">
                Clean single-line marquee with Hudson Club messaging
              </p>
              <div className="border border-gray-200 rounded-lg overflow-hidden">
                <SingleMarquee />
              </div>
            </div>

            {/* Multiple Marquees */}
            <div>
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">
                Multiple Marquee Stack
              </h2>
              <p className="text-gray-600 mb-6">
                Multiple marquee lines with different messaging and speeds
              </p>
              <div className="border border-gray-200 rounded-lg overflow-hidden">
                <HudsonMarquee />
              </div>
            </div>

            {/* Custom Marquee Examples */}
            <div>
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">
                Custom Marquee Variations
              </h2>
              <div className="space-y-4">
                <div>
                  <h3 className="text-lg font-medium text-gray-900 mb-2">Fast Speed</h3>
                  <Marquee 
                    text="THE HUDSON CLUB™ • WHERE HOMES ARE MASTERPIECES"
                    speed={25}
                  />
                </div>
                
                <div>
                  <h3 className="text-lg font-medium text-gray-900 mb-2">Medium Speed</h3>
                  <Marquee 
                    text="WE MAINTAIN YOUR HOME SO YOU DON'T HAVE TO"
                    speed={45}
                  />
                </div>
                
                <div>
                  <h3 className="text-lg font-medium text-gray-900 mb-2">Slow Speed</h3>
                  <Marquee 
                    text="EFFORTLESS HOMEOWNERSHIP • PRECISION CARE • PROACTIVE PLANNING"
                    speed={80}
                  />
                </div>
              </div>
            </div>

            {/* Usage Instructions */}
            <div className="bg-white p-8 rounded-lg border border-gray-200">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">
                Usage & Integration
              </h2>
              
              <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                <div>
                  <h3 className="text-lg font-medium text-gray-900 mb-3">Perfect Placements:</h3>
                  <ul className="space-y-2 text-gray-600">
                    <li>• Between hero and main content</li>
                    <li>• Above or below testimonials</li>
                    <li>• Footer accent element</li>
                    <li>• Page transitions</li>
                    <li>• Loading states</li>
                  </ul>
                </div>
                
                <div>
                  <h3 className="text-lg font-medium text-gray-900 mb-3">Design Specs:</h3>
                  <ul className="space-y-2 text-gray-600">
                    <li>• Height: 59px (Figma exact)</li>
                    <li>• Background: rgb(82, 76, 61)</li>
                    <li>• Text: White, 12px, uppercase</li>
                    <li>• Animation: Smooth linear scroll</li>
                    <li>• Responsive: Full width</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default MarqueeDemoPage 